import { useState } from 'react';
import { usePayment } from '../contexts/PaymentContext';
import { apiService } from '../services/api';

export const usePaymentModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const { startPaymentTransaction, updatePaymentStatus } = usePayment();

  const openModal = () => {
    setIsModalOpen(true);
    setError(null);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setError(null);
    setIsLoading(false);
  };

  const processPayment = async (packageType) => {
    try {
      setIsLoading(true);
      setError(null);
      
      // Start payment transaction tracking
      startPaymentTransaction({
        packageType,
        timestamp: new Date().toISOString(),
        status: 'initiated'
      });

      // Create Stripe checkout session
      const response = await apiService.payment.createWhizzCheckout({
        package: packageType,
        package_id: packageType,
        origin_url: window.location.origin
      });

      if (response.data.success && response.data.checkout_url) {
        // Update payment status
        updatePaymentStatus('processing', 'Redirecting to Stripe checkout...');
        
        // Redirect to Stripe
        window.location.href = response.data.checkout_url;
      } else {
        throw new Error(response.data.message || 'Failed to create payment session');
      }
    } catch (error) {
      console.error('Payment error:', error);
      const errorMessage = error.response?.data?.detail || error.message || 'Payment failed. Please try again.';
      setError(errorMessage);
      updatePaymentStatus('error', errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isModalOpen,
    isLoading,
    error,
    openModal,
    closeModal,
    processPayment
  };
};